import { DOMAIN } from "constants/schema";
import { MainServer } from "./main";

export const MainServices: { services: MainServer } = {
  services: new MainServer({
    BASE: DOMAIN,
  }),
};
